export const NutritionalStandard = [
  {
    id: -21,
    description: 'Supper: SFSP',
  },
  {
    id: -20,
    description: 'Snack: SFSP',
  },
  {
    id: -19,
    description: 'Lunch: SFSP',
  },
  {
    id: -18,
    description: 'Breakfast: SFSP',
  },
  {
    id: -17,
    description: 'Snack: Preschool',
  },
  {
    id: -16,
    description: 'Lunch: Preschool',
  },
  {
    id: -15,
    description: 'Breakfast: Preschool',
  },
  {
    id: -14,
    description: 'Supper: 3 - 5',
  },
  {
    id: -12,
    description: 'Supper: 6 - 12',
  },
  {
    id: -11,
    description: 'Supper: 13 - 18',
  },
  {
    id: -10,
    description: 'After-school Snack',
  },
  {
    id: -9,
    description: 'Breakfast: K - 12',
  },
  {
    id: -8,
    description: 'Breakfast: K - 5',
  },
  {
    id: -7,
    description: 'Breakfast: K - 8',
  },
  {
    id: -6,
    description: 'Breakfast: 6 - 8',
  },
  {
    id: -5,
    description: 'Breakfast: 9 - 12',
  },
  {
    id: -4,
    description: 'Lunch: K - 5',
  },
  {
    id: -3,
    description: 'Lunch: K - 8',
  },
  {
    id: -2,
    description: 'Lunch: 6 - 8',
  },
  {
    id: -1,
    description: 'Lunch: 9 - 12',
  },
];

export const NutritionalStandardMap = NutritionalStandard.reduce(
  (accumulator, standard) => {
    accumulator[standard.id] = standard.description;

    return accumulator;
  },
  {}
);



// WEBPACK FOOTER //
// ./src/common/Constants/NutritionalStandard.js